import React from 'react';
import { connect } from 'react-redux';
import sample from 'lodash/sample';
import { MODAL_LAYOUT, ONBOARDING_STEP } from '../../constants';
import { hideModal } from '../../actions/modal';
import { setRuntimeVariable } from '../../actions/runtime';
import { getStep } from '../../actions/user';
import Button from '../../components/Button';
import { Brandmark } from '../../components/Icons';
import Link from '../../components/Link';
import Modal from '../../components/Modal';
import SignupScroller from '../../components/SignupScroller';
import Video from '../../components/Video';
import Style from '../../components/Style';
import { L3, H3, P1 } from '../../components/Typography';
import OnboardingContainer from '../OnboardingContainer';

import onboardingVideo from '../../assets/onboarding.mp4';
import onboardingPoster from '../../assets/onboarding.jpg';

function mapStateToProps(state) {
  const styles = { leftStyle: { opacity: 0 }, closeButtonStyle: {} };
  let layout = MODAL_LAYOUT.EQUAL_SPLIT;

  switch (getStep(state)) {
    case ONBOARDING_STEP.PLAN:
    case ONBOARDING_STEP.PAY:
      styles.leftStyle.opacity = 1;
      layout = MODAL_LAYOUT.RIGHT;
      break;
    case ONBOARDING_STEP.COMPLETE:
      styles.leftStyle.opacity = 0;
      styles.closeButtonStyle.opacity = 0;
      layout = MODAL_LAYOUT.FULL;
      break;
  }

  return {
    layout: layout,
    styles: styles,
    backgroundContent: <VideoBackground />,
    fullContent: <Welcome />,
    leftContent: <Logo />,
    rightContent: <OnboardingContainer {...state.modal.props} />,
    colors: state.ui.colors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onClose: () => dispatch(hideModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);

function WelcomeComp({ newUser, onClose }) {
  let headline = 'Welcome back to Storytape.';
  let statement = 'So good to see you again. We love shooting for you.';
  let profileCTA = 'View your profile';
  if (newUser) {
    headline = 'Welcome to Storytape.';
    statement = 'We hope you enjoy the experience. We love shooting for you.';
    profileCTA = 'Complete your profile';
  }

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
      }}
    >
      <div
        style={{
          flexBasis: '20%',
          width: '20%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          paddingTop: '6rem',
        }}
      >
        <Brandmark color={Style.Colors.white} />
      </div>
      <div
        style={{
          flexBasis: '80%',
          width: '80%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <L3 style={{ color: Style.Colors.shadow3 }}>SUCCESS!</L3>
        <H3>{headline}</H3>
        <P1 style={{ opacity: 0.75, margin: '0 0 4.5rem' }}>{statement}</P1>
        <div>
          <Link onClick={onClose} to="/browse">
            <Button baseColor={Style.Colors.black} arrow={true}>
              Start Browsing
            </Button>
          </Link>
          <div style={{ display: 'none' }}>
            <span style={{ margin: '0 2rem' }}>or</span>
            <Link onClick={onClose} to="/dashboard/profile">
              <Button
                style={{ borderWidth: '0.1rem' }}
                baseColor={Style.Colors.black}
              >
                {profileCTA}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToWelcomeProps(state) {
  return {
    newUser: state.runtime.newUser,
  };
}

function mapDispatchToWelcomeProps(dispatch) {
  return {
    onClose: () => setTimeout(() => dispatch(hideModal()), 500),
  };
}

const Welcome = connect(mapStateToWelcomeProps, mapDispatchToWelcomeProps)(
  WelcomeComp,
);

function Logo() {
  return (
    <div
      style={{
        padding: '6rem 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <Brandmark color={Style.Colors.white} />
    </div>
  );
}

function VideoBackground() {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        backgroundColor: Style.Colors.black,
      }}
    >
      <Video
        src={onboardingVideo}
        poster={onboardingPoster}
        style={{
          height: 'calc(100% + 1px)',
        }}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/OnboardingModal/OnboardingModal.js